module.exports = __webpack_public_path__ + "media/images/icon/icon-arrow-right-823ebd1adfa709cf446584830ea22742.svg";